import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { AdminPanelDealsFilterRequestDto } from "../../../api/apiServices/backOffice/controllers/adminPanel/adminPanel.requestsDto";
import { DealLiteModel } from "../../../viewModels/Deal/DealModel";

const initialState: {
  loading: boolean;
  loaded: boolean;
  error: boolean;
  deals?: Array<DealLiteModel>;
  total: number;
} = {
  loading: true,
  loaded: false,
  error: false,
  deals: undefined,
  total: 0,
};

const adminPanelDealsSlice = createSlice({
  name: "adminPanelDeals",
  initialState,
  reducers: {
    loadDeals(state, _action: PayloadAction<AdminPanelDealsFilterRequestDto>) {
      state.loading = true;
      state.error = false;
    },
    loadDealsSuccess(state, action: PayloadAction<{ deals?: Array<DealLiteModel>; total: number }>) {
      state.loading = false;
      state.loaded = true;
      state.error = false;
      state.deals = action.payload.deals;
      state.total = action.payload.total;
    },
    loadDealsFailure(state) {
      state.loading = false;
      state.error = true;
    },
  },
});

export default adminPanelDealsSlice;
